import React from 'react'
import { Accordion, Col, Container, Row } from 'react-bootstrap'
import '../pages/FAQ.css'

const faqData = [
    {
        question: '1. What is arbitration?',
        answer: 'Arbitration is a private dispute resolution process where the parties agree to submit their dispute to an impartial arbitrator, whose decision (award) is binding on the parties.',
    },
    {
        question: '2. How is arbitration different from a court case?',
        answer: 'Arbitration is generally faster, more cost-effective, confidential, and less formal than traditional court proceedings. The dispute is decided by an arbitrator instead of a judge.',
    },
    {
        question: '3. What types of disputes can be referred to arbitration?',
        answer: 'Commercial disputes, loan and finance disputes, contractual disputes, partnership disputes, recovery matters, and various other civil disputes can be referred to arbitration if there is a valid arbitration agreement between the parties.',
    },
    {
        question: '4. What is mediation?',
        answer: 'Mediation is a voluntary process where a neutral mediator assists the parties in reaching a mutually acceptable settlement without imposing a decision.',
    },
    {
        question: '5. Is mediation mandatory before arbitration?',
        answer: 'Not necessarily. It depends upon the agreement between the parties or any applicable legal requirements. However, mediation is often encouraged as it may resolve disputes amicably.',
    },
    {
        question: '6. What is an arbitral award?',
        answer: 'An arbitral award is the final decision issued by the arbitrator after considering the submissions and evidence of both parties. It is legally enforceable under the Arbitration and Conciliation Act, 1996.',
    },
    {
        question: '7. Is an arbitral award legally binding?',
        answer: 'Yes. An arbitral award is binding upon the parties and can be enforced in the same manner as a court decree, subject to applicable legal provisions.',
    },
    {
        question: '8. Can an arbitral award be challenged?',
        answer: 'Yes. An arbitral award may be challenged before the competent court under Section 34 of the Arbitration and Conciliation Act, 1996, on limited grounds specified under the Act.',
    },
    {
        question: '9. How long does the arbitration process take?',
        answer: 'The duration depends upon the complexity of the dispute. However, arbitration is generally quicker than conventional court litigation.',
    },
    {
        question: '10. Can arbitration proceedings be conducted online?',
        answer: 'Yes. Hearings, submissions, and communications can be conducted through virtual platforms, subject to the directions of the arbitrator and applicable laws.',
    },
    {
        question: '11. What documents are required to initiate arbitration?',
        answer: 'Generally, the arbitration agreement, contract, loan documents, notices, correspondence, and supporting evidence relating to the dispute are required.',
    },
    {
        question: '12. Who appoints the arbitrator?',
        answer: 'The appointment of an arbitrator is usually governed by the arbitration agreement between the parties. In certain cases, the appointment may be made through a designated institution or by a competent court.',
    },
    {
        question: '13. What are the benefits of arbitration?',
        list: [
            'Faster resolution',
            'Confidential proceedings',
            'Flexible procedure',
            'Cost-effective process',
            'Expert decision-makers',
            'Enforceable awards',
            'Virtual which makes it easier to attend from anywhere.',
        ],
    },
    {
        question: '14. Is my information kept confidential?',
        answer: 'Yes. Arbitration and mediation proceedings are generally confidential, and all information is handled with appropriate care and discretion.',
    },
    {
        question: '15. Can individuals and businesses both use your services?',
        answer: 'Yes. Our services are available to individuals, financial institutions, NBFCs, banks, corporates, partnerships, and other business entities.',
    },
    {
        question: '16. How can I start the dispute resolution process?',
        answer: 'You may contact us through our website, email, or phone. Our team will review your requirements and guide you through the appropriate dispute resolution mechanism.',
    },
    {
        question: '17. What is a pre-arbitration notice?',
        answer: 'A pre-arbitration notice is a formal communication issued to the opposite party before initiating arbitration, providing an opportunity to resolve the dispute or comply with contractual obligations.',
    },
    {
        question: '18. What happens if the respondent does not participate in arbitration?',
        answer: 'If proper notice has been served and the respondent fails to appear without sufficient cause, the arbitrator may proceed with the matter in accordance with applicable law.',
    },
    {
        question: '19. Can lenders initiate arbitration for loan recovery?',
        answer: 'Yes. Where the loan agreement contains a valid arbitration clause, lenders may initiate arbitration proceedings for recovery of outstanding dues, subject to applicable laws.',
    },
    {
        question: '20. Why choose REAA?',
        answer: 'REAA provides a professional, efficient, transparent, and legally compliant dispute resolution framework with experienced professionals dedicated to timely resolution of disputes.',
    },
]

function FAQ() {
    return (
        <Container fluid className='FAQContainer'>
            <Row className='justify-content-center'>
                <Col md={10} className='text-center'>
                    <h2 className='faqHeading'>
                        Frequently Asked Questions
                    </h2>
                    <p className='faqSubheading'>
                        Find answers to common inquiries about our processes and ODR.
                    </p>
                </Col>
            </Row>
            <Row className='justify-content-center mt-4'>
                <Col md={9}>
                    <Accordion className='faqAccordion mb-5'>
                        {faqData.map((item, index) => (
                            <Accordion.Item eventKey={String(index)} key={index}>
                                <Accordion.Header>{item.question}</Accordion.Header>
                                <Accordion.Body>
                                    {item.list ? (
                                        <ul className='faqList'>
                                            {item.list.map((point, i) => (
                                                <li key={i}>{point}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p>{item.answer}</p>
                                    )}
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </Col>
            </Row>
        </Container>
    )
}

export default FAQ
